import { setClientBiomarkerCategories } from '../../redux/client/action'
import { setSubMenu } from '../../redux/slideMenu/action'

export default dispatch => ({
  setClientBiomarkerCategories: categories =>
    dispatch(setClientBiomarkerCategories(categories)),
  setSubMenu: (type, subMenu) => dispatch(setSubMenu(type, subMenu))
})
